import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import {OfferOption} from "../models/offer/offer-option";
import {OfferOptionService} from "../services/offer/offer-option.service";

@Injectable({
    providedIn: 'root'
})
export class OfferOptionItemResolver  {

    constructor(
        private _offerOptionService: OfferOptionService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

        return this._offerOptionService.getItemAPI(parseInt(route.paramMap.get('id')));
    }
}
